import { IDistributionType, TEMPLATE_TYPE } from 'services/templates/types';
import { DISTRIBUTION_FORM } from './types';

const distributionFormByTemplateType: Record<
  IDistributionType,
  DISTRIBUTION_FORM
> = {
  [TEMPLATE_TYPE.digitalDistribution]: DISTRIBUTION_FORM.Digital,
  [TEMPLATE_TYPE.physicalDistribution]: DISTRIBUTION_FORM.Physical,
  [TEMPLATE_TYPE.merchDistribution]: DISTRIBUTION_FORM.Merch,
  [TEMPLATE_TYPE.channelDistribution]: DISTRIBUTION_FORM.Youtube,
};

export const getDistributionFormByTemplateType = (
  type: IDistributionType
): DISTRIBUTION_FORM => distributionFormByTemplateType[type];
